import React, { useCallback, useEffect, useRef, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const TIPO_ICONE:Record<string,string> = {
  manutencao:"🔧", telemetria:"📡", relatorios:"📊", geral:"📧"
}
const TIPO_DESC:Record<string,string> = {
  manutencao:"Alertas de manutenção e OS do checklist",
  telemetria:"Alertas de movimento, cercas, chips, offline e checklist",
  relatorios:"Relatórios agendados e fechamento da IA",
  geral:"Senhas e acessos (usuários do painel e app do motorista)"
}

function PerfisEmail() {
  const [configs, setConfigs]   = useState<any[]>([])
  const [editando, setEditando] = useState<any>(null)
  const [form, setForm]         = useState<any>({})
  const [emailTeste, setEmailTeste] = useState("")
  const [loading, setLoading]   = useState(true)
  const [salvando, setSalvando] = useState(false)
  const [testando, setTestando] = useState(false)
  const [msg, setMsg]           = useState<{texto:string,tipo:"ok"|"erro"}|null>(null)

  const carregar = async () => {
    try {
      const r = await axios.get(`${API}/email-config`)
      setConfigs(r.data)
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const abrirEditar = (cfg:any) => {
    setEditando(cfg)
    setForm({
      nome:cfg.nome||"", smtp_host:cfg.smtp_host||"",
      smtp_porta:cfg.smtp_porta||465, smtp_seguro:cfg.smtp_seguro??true,
      smtp_usuario:cfg.smtp_usuario||"", smtp_senha:"",
      email_remetente:cfg.email_remetente||"",
      nome_remetente:cfg.nome_remetente||"", ativo:cfg.ativo??true
    })
    setMsg(null)
  }

  const salvar = async () => {
    setSalvando(true)
    try {
      await axios.put(`${API}/email-config/${editando.id}`, form)
      setMsg({texto:"✅ Configuração salva!", tipo:"ok"})
      carregar()
    } catch(e:any) {
      setMsg({texto:`❌ ${e.response?.data?.erro||"Erro ao salvar"}`, tipo:"erro"})
    } finally { setSalvando(false) }
  }

  const testar = async () => {
    if (!emailTeste) return alert("Informe um email para teste")
    setTestando(true)
    try {
      const r = await axios.post(`${API}/email-config/testar/${editando.id}`, {email_teste:emailTeste})
      setMsg({texto:`✅ ${r.data.mensagem}`, tipo:"ok"})
    } catch(e:any) {
      setMsg({texto:`❌ Falha: ${e.response?.data?.erro||"Erro"}`, tipo:"erro"})
    } finally { setTestando(false) }
  }

  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
        {/* Lista de configs */}
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:12}}>📋 Perfis de e-mail</div>
          {loading ? <div style={{color:"#64748b"}}>Carregando...</div> :
          configs.map((cfg:any)=>(
            <div key={cfg.id} onClick={()=>abrirEditar(cfg)}
              style={{background:editando?.id===cfg.id?"#0c2a4a":"#0d1b2e",
                border:`1px solid ${editando?.id===cfg.id?"#0ea5e9":"#2d4166"}`,
                borderRadius:8,padding:"14px 16px",marginBottom:8,cursor:"pointer"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontWeight:600,fontSize:14}}>
                    {TIPO_ICONE[cfg.tipo]||"📧"} {cfg.nome}
                  </div>
                  <div style={{fontSize:11,color:"#64748b",marginTop:2}}>{TIPO_DESC[cfg.tipo]||""}</div>
                  <div style={{fontSize:11,color:"#475569",marginTop:4,fontFamily:"monospace"}}>
                    {cfg.smtp_usuario||"Não configurado"}
                  </div>
                </div>
                <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4}}>
                  <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,
                    background:cfg.ativo?"#14532d":"#1e293b",
                    color:cfg.ativo?"#4ade80":"#64748b"}}>
                    {cfg.ativo?"✅ Ativo":"⏸ Inativo"}
                  </span>
                  {cfg.smtp_host && <span style={{fontSize:9,color:"#475569"}}>{cfg.smtp_host}:{cfg.smtp_porta}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Formulário de edição */}
        {editando ? (
          <div className="card">
            <div style={{fontWeight:700,fontSize:14,marginBottom:16}}>
              ✏️ Editar — {editando.nome}
            </div>

            {msg && (
              <div style={{padding:"10px 14px",borderRadius:8,marginBottom:12,fontSize:12,
                background:msg.tipo==="ok"?"#14532d":"#450a0a",
                color:msg.tipo==="ok"?"#4ade80":"#f87171"}}>
                {msg.texto}
              </div>
            )}

            <div className="form-grid">
              <div className="form-group full">
                <label>Nome do perfil</label>
                <input value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}
                  placeholder="Ex: Manutenção" />
              </div>
              <div className="form-group">
                <label>🖥️ Servidor SMTP</label>
                <input value={form.smtp_host} onChange={e=>setForm({...form,smtp_host:e.target.value})}
                  placeholder="mail.dominio.com.br" style={{fontFamily:"monospace"}} />
              </div>
              <div className="form-group">
                <label>🔌 Porta</label>
                <select value={form.smtp_porta} onChange={e=>setForm({...form,smtp_porta:parseInt(e.target.value)})}>
                  <option value={465}>465 (SSL)</option>
                  <option value={587}>587 (TLS)</option>
                  <option value={25}>25 (SMTP)</option>
                </select>
              </div>
              <div className="form-group full">
                <label>👤 Usuário SMTP</label>
                <input value={form.smtp_usuario} onChange={e=>setForm({...form,smtp_usuario:e.target.value})}
                  placeholder="email@dominio.com.br" style={{fontFamily:"monospace"}} />
              </div>
              <div className="form-group full">
                <label>🔑 Senha SMTP <span style={{fontSize:10,color:"#475569"}}>(deixe vazio para manter atual)</span></label>
                <input type="password" value={form.smtp_senha}
                  onChange={e=>setForm({...form,smtp_senha:e.target.value})}
                  placeholder="••••••••" />
              </div>
              <div className="form-group">
                <label>📧 E-mail remetente</label>
                <input value={form.email_remetente} onChange={e=>setForm({...form,email_remetente:e.target.value})}
                  placeholder="notif@dominio.com.br" style={{fontFamily:"monospace"}} />
              </div>
              <div className="form-group">
                <label>✏️ Nome remetente</label>
                <input value={form.nome_remetente} onChange={e=>setForm({...form,nome_remetente:e.target.value})}
                  placeholder="MoobiFleet Manutenção" />
              </div>
              <div className="form-group full">
                <label>🔒 Conexão segura (SSL/TLS)</label>
                <div style={{display:"flex",gap:8,marginTop:4}}>
                  {[{v:true,l:"✅ Segura (SSL)"},{v:false,l:"⚠️ Sem SSL"}].map(op=>(
                    <div key={String(op.v)} onClick={()=>setForm({...form,smtp_seguro:op.v})}
                      style={{flex:1,padding:"8px 12px",borderRadius:8,cursor:"pointer",textAlign:"center",
                        border:`2px solid ${form.smtp_seguro===op.v?"#22c55e":"#2d4166"}`,
                        background:form.smtp_seguro===op.v?"#0d2e1a":"transparent",
                        fontSize:12,color:form.smtp_seguro===op.v?"#22c55e":"#94a3b8"}}>
                      {op.l}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={{display:"flex",gap:8,marginTop:16}}>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando} style={{flex:1}}>
                {salvando?"⏳ Salvando...":"💾 Salvar"}
              </button>
            </div>

            {/* Teste de envio */}
            <div style={{marginTop:16,paddingTop:16,borderTop:"1px solid #2d4166"}}>
              <div style={{fontSize:12,fontWeight:600,color:"#94a3b8",marginBottom:8}}>🧪 Testar configuração</div>
              <div style={{display:"flex",gap:8}}>
                <input value={emailTeste} onChange={e=>setEmailTeste(e.target.value)}
                  placeholder="email@teste.com" style={{flex:1,fontSize:12}} />
                <button className="btn btn-ghost" onClick={testar} disabled={testando}
                  style={{fontSize:12,whiteSpace:"nowrap"}}>
                  {testando?"⏳":"📨"} Testar
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",color:"#475569",fontSize:13}}>
            ← Selecione um perfil para editar
          </div>
        )}
      </div>
    </div>
  )
}


// ---------------------------------------------------------------------------------------------
// MODELOS (HTML) DOS E-MAILS: editor com variaveis, pre-visualizacao ao vivo, teste de envio, versoes e "restaurar padrao"
// ---------------------------------------------------------------------------------------------
const erroMsg = (e:any) => e?.response?.data?.erro || "Erro ao falar com o servidor"
const dataHora = (iso:string|null) => iso ? new Date(iso).toLocaleString("pt-BR",{day:"2-digit",month:"2-digit",year:"2-digit",hour:"2-digit",minute:"2-digit"}) : ""

function ModelosEmail() {
  const [lista, setLista]       = useState<any[]>([])
  const [nome, setNome]         = useState<string|null>(null)
  const [det, setDet]           = useState<any>(null)
  const [texto, setTexto]       = useState("")
  const [previa, setPrevia]     = useState("")
  const [erroPrevia, setErroPrevia] = useState("")
  const [msg, setMsg]           = useState<{texto:string,tipo:"ok"|"erro"}|null>(null)
  const [salvando, setSalvando] = useState(false)
  const [confirmaRestaurar, setConfirmaRestaurar] = useState(false)
  const [emailTeste, setEmailTeste] = useState("")
  const [enviando, setEnviando] = useState(false)
  const area = useRef<HTMLTextAreaElement>(null)

  const carregarLista = useCallback(async () => {
    try { setLista((await axios.get(`${API}/email-config/templates`)).data) } catch (e) { setMsg({texto:`❌ ${erroMsg(e)}`, tipo:"erro"}) }
  }, [])
  useEffect(()=>{ carregarLista() },[carregarLista])

  const sujo = !!det && texto !== det.html

  const abrir = async (n:string) => {
    if (sujo && !window.confirm("Há alterações não salvas neste modelo. Descartar e abrir outro?")) return
    setMsg(null); setConfirmaRestaurar(false)
    try {
      const r = await axios.get(`${API}/email-config/templates/${n}`)
      setNome(n); setDet(r.data); setTexto(r.data.html); setErroPrevia("")
    } catch (e) { setMsg({texto:`❌ ${erroMsg(e)}`, tipo:"erro"}) }
  }

  // pre-visualizacao ao vivo (espera 600 ms depois da ultima tecla)
  useEffect(()=>{
    if (!nome || !det) return
    const t = setTimeout(async () => {
      try { const r = await axios.post(`${API}/email-config/templates/${nome}/previa`, {html:texto}); setPrevia(r.data.html); setErroPrevia("") }
      catch (e) { setErroPrevia(erroMsg(e)) }
    }, 600)
    return () => clearTimeout(t)
  },[texto, nome, det])

  const inserir = (v:{nome:string,cru?:boolean}) => {
    const marca = v.cru ? `{{{${v.nome}}}}` : `{{${v.nome}}}`
    const el = area.current
    if (!el) { setTexto(texto + marca); return }
    const a = el.selectionStart ?? texto.length, b = el.selectionEnd ?? texto.length
    setTexto(texto.slice(0,a) + marca + texto.slice(b))
    setTimeout(()=>{ el.focus(); el.setSelectionRange(a+marca.length, a+marca.length) }, 0)
  }

  const salvar = async () => {
    if (!nome) return
    setSalvando(true); setMsg(null)
    try {
      await axios.put(`${API}/email-config/templates/${nome}`, {html:texto})
      const r = await axios.get(`${API}/email-config/templates/${nome}`)
      setDet(r.data); setMsg({texto:"✅ Modelo salvo. Vale a partir do próximo e-mail enviado.", tipo:"ok"}); carregarLista()
    } catch (e) { setMsg({texto:`❌ ${erroMsg(e)}`, tipo:"erro"}) } finally { setSalvando(false) }
  }

  const restaurar = async () => {
    if (!nome) return
    try {
      const r = await axios.delete(`${API}/email-config/templates/${nome}`)
      const d = await axios.get(`${API}/email-config/templates/${nome}`)
      setDet(d.data); setTexto(r.data.html); setConfirmaRestaurar(false)
      setMsg({texto:"✅ Voltou ao modelo padrão.", tipo:"ok"}); carregarLista()
    } catch (e) { setMsg({texto:`❌ ${erroMsg(e)}`, tipo:"erro"}) }
  }

  const carregarVersao = async (id:string) => {
    if (!nome || !id) return
    try { const r = await axios.get(`${API}/email-config/templates/${nome}/versoes/${id}`); setTexto(r.data.html); setMsg({texto:"Versão anterior carregada no editor. Clique em Salvar para usá-la.", tipo:"ok"}) }
    catch (e) { setMsg({texto:`❌ ${erroMsg(e)}`, tipo:"erro"}) }
  }

  const testar = async () => {
    if (!nome) return
    if (!emailTeste.trim()) { setMsg({texto:"❌ Informe o e-mail que vai receber o teste", tipo:"erro"}); return }
    setEnviando(true); setMsg(null)
    try { const r = await axios.post(`${API}/email-config/templates/${nome}/testar`, {email:emailTeste.trim(), html:texto}); setMsg({texto:`✅ ${r.data.mensagem}`, tipo:"ok"}) }
    catch (e) { setMsg({texto:`❌ ${erroMsg(e)}`, tipo:"erro"}) } finally { setEnviando(false) }
  }

  return (
    <div>
      <p style={{fontSize:12,color:"#64748b",marginBottom:14}}>
        Edite o HTML dos e-mails do sistema. A <b>moldura</b> vale para todos; os outros modelos são o texto de cada e-mail. As variáveis entre chaves {"{{ }}"} são trocadas pelos dados reais no envio.
      </p>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16}}>
        {lista.map((m:any)=>(
          <div key={m.nome} onClick={()=>abrir(m.nome)} role="button" aria-label={`Editar modelo ${m.titulo}`}
            style={{cursor:"pointer",padding:"10px 14px",borderRadius:8,minWidth:200,maxWidth:260,
              background:nome===m.nome?"#0c2a4a":"#0d1b2e",border:`1px solid ${nome===m.nome?"#0ea5e9":"#2d4166"}`}}>
            <div style={{fontWeight:600,fontSize:13}}>{m.titulo}</div>
            <div style={{fontSize:10,color:"#64748b",marginTop:3}}>{m.descricao}</div>
            <div style={{fontSize:10,marginTop:5,color:m.personalizado?"#fbbf24":"#475569"}}>{m.personalizado?`✏️ Personalizado · ${dataHora(m.atualizado_em)}`:"Modelo padrão"}</div>
          </div>
        ))}
      </div>

      {msg && (
        <div role="status" style={{padding:"10px 14px",borderRadius:8,marginBottom:12,fontSize:12,background:msg.tipo==="ok"?"#14532d":"#450a0a",color:msg.tipo==="ok"?"#4ade80":"#f87171"}}>{msg.texto}</div>
      )}

      {!det ? (
        <div style={{color:"#475569",fontSize:13,padding:24,textAlign:"center",border:"1px dashed #2d4166",borderRadius:8}}>Escolha um modelo acima para editar</div>
      ) : (
        <div style={{display:"grid",gridTemplateColumns:"minmax(0,1fr) minmax(0,1fr)",gap:16}}>
          <div className="card">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,gap:8,flexWrap:"wrap"}}>
              <div style={{fontWeight:700,fontSize:14}}>✏️ {det.titulo}</div>
              {sujo && <span style={{fontSize:11,color:"#fbbf24"}}>● alterações não salvas</span>}
            </div>
            <div style={{fontSize:11,color:"#94a3b8",marginBottom:6}}>Variáveis (clique para inserir no cursor)</div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10}}>
              {det.variaveis.map((v:any)=>(
                <button key={v.nome} className="btn btn-ghost" title={`${v.descricao}${v.cru?" — HTML pronto, não é escapado":""}`} onClick={()=>inserir(v)}
                  style={{padding:"2px 8px",fontSize:11,fontFamily:"monospace"}}>{v.cru?`{{{${v.nome}}}}`:`{{${v.nome}}}`}</button>
              ))}
            </div>
            <textarea ref={area} aria-label="HTML do modelo" value={texto} spellCheck={false} onChange={e=>setTexto(e.target.value)} wrap="off"
              style={{width:"100%",height:380,fontFamily:"Consolas,Menlo,monospace",fontSize:12,lineHeight:1.5,boxSizing:"border-box",whiteSpace:"pre",overflow:"auto",resize:"vertical"}} />
            {erroPrevia && <div role="alert" style={{fontSize:12,color:"#f87171",marginTop:6}}>⚠️ {erroPrevia}</div>}
            <div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap",alignItems:"center"}}>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando || !sujo || !!erroPrevia}>{salvando?"⏳ Salvando...":"💾 Salvar modelo"}</button>
              {!confirmaRestaurar
                ? <button className="btn btn-ghost" disabled={!det.personalizado} title={det.personalizado?"Descarta a personalização e volta ao modelo original":"Este modelo já é o padrão"} onClick={()=>setConfirmaRestaurar(true)}>↩️ Restaurar padrão</button>
                : <span style={{display:"flex",gap:6,alignItems:"center",fontSize:12}}>Voltar ao padrão?
                    <button className="btn btn-primary" style={{padding:"4px 10px"}} onClick={restaurar}>Sim, restaurar</button>
                    <button className="btn btn-ghost" style={{padding:"4px 10px"}} onClick={()=>setConfirmaRestaurar(false)}>Não</button></span>}
              {det.versoes?.length > 0 && (
                <select aria-label="Versões anteriores" value="" onChange={e=>carregarVersao(e.target.value)} style={{fontSize:12,maxWidth:230}}>
                  <option value="">🕘 Versões anteriores ({det.versoes.length})…</option>
                  {det.versoes.map((v:any)=><option key={v.id} value={v.id}>{dataHora(v.criado_em)}{v.por?` · ${v.por}`:""}</option>)}
                </select>
              )}
            </div>
            <div style={{marginTop:14,paddingTop:12,borderTop:"1px solid #2d4166"}}>
              <div style={{fontSize:12,fontWeight:600,color:"#94a3b8",marginBottom:6}}>🧪 Enviar este rascunho como teste</div>
              <div style={{display:"flex",gap:8}}>
                <input aria-label="E-mail do teste" value={emailTeste} onChange={e=>setEmailTeste(e.target.value)} placeholder="seu@email.com" style={{flex:1,fontSize:12}} />
                <button className="btn btn-ghost" onClick={testar} disabled={enviando} style={{fontSize:12,whiteSpace:"nowrap"}}>{enviando?"⏳":"📨"} Enviar teste</button>
              </div>
              <div style={{fontSize:10,color:"#64748b",marginTop:4}}>Sai pelo remetente do tipo de e-mail (aba Perfis), com dados de exemplo. Não salva nada.</div>
            </div>
          </div>
          <div className="card" style={{padding:12}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:8}}>👁️ Pré-visualização</div>
            <iframe title="Pré-visualização do e-mail" sandbox="" srcDoc={previa} style={{width:"100%",height:560,border:"1px solid #2d4166",borderRadius:8,background:"#fff"}} />
            <div style={{fontSize:10,color:"#64748b",marginTop:4}}>Com dados de exemplo. A pré-visualização atualiza ao digitar.</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default function EmailConfig() {
  const [aba, setAba] = useState<"perfis"|"modelos">("perfis")
  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{marginBottom:16}}>
        <h2 style={{fontSize:20,fontWeight:700}}>⚙️ Configuração de E-mail</h2>
        <p style={{fontSize:13,color:"#64748b"}}>Servidores SMTP (quem envia cada tipo de e-mail) e os modelos HTML dos e-mails</p>
      </div>
      <div style={{display:"flex",gap:6,marginBottom:18}}>
        <button className={aba==="perfis"?"btn btn-primary":"btn btn-ghost"} onClick={()=>setAba("perfis")}>📋 Perfis (remetentes)</button>
        <button className={aba==="modelos"?"btn btn-primary":"btn btn-ghost"} onClick={()=>setAba("modelos")}>🎨 Modelos (HTML)</button>
      </div>
      {aba==="perfis" ? <PerfisEmail /> : <ModelosEmail />}
    </div>
  )
}
